import { getParam } from '@integration-frontends/apps/common/utils';
import { DI_CONTAINER } from '@integration-frontends/core';
import { IGetAuthToken } from '@integration-frontends/integration/infrastructure/isomorphic';
import { IDENTITY_STORE_TOKEN, IIdentityStore } from './common';

const getApiKeyParamStrategy: IGetAuthToken = async () => {
  return getParam('apiKey');
};

const getApiKeyIdentityStrategy: IGetAuthToken = async () => {
  const identityStore: IIdentityStore = DI_CONTAINER.get(IDENTITY_STORE_TOKEN);
  return (await identityStore.get())?.token;
};

export const getApiKeyCustomStrategy: IGetAuthToken = async () =>
  (await getApiKeyParamStrategy()) || (await getApiKeyIdentityStrategy());
